import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/sportsData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setSearchOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-flashlight-fill text-lg text-white"></i>
            </div>
            <span className="text-xl font-heading font-bold text-foreground-900 tracking-wide">
              极速体育
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === "/"
                  ? "text-primary-600 bg-primary-100/70"
                  : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 5).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? "text-primary-600 bg-primary-100/70"
                    : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === "/about"
                  ? "text-primary-600 bg-primary-100/70"
                  : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="flex items-center gap-2">
            <div className="relative">
              <button
                onClick={() => setSearchOpen(!searchOpen)}
                className="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
              >
                <i className="ri-search-line text-lg text-foreground-700"></i>
              </button>
              {searchOpen && (
                <div className="absolute right-0 top-12 w-72 bg-background-50 rounded-xl border border-background-200/70 p-3">
                  <div className="flex items-center gap-2 bg-background-100 rounded-lg px-3 py-2">
                    <i className="ri-search-line text-sm text-foreground-500"></i>
                    <input
                      type="text"
                      placeholder="搜索赛事、资讯..."
                      className="bg-transparent border-none outline-none text-sm text-foreground-900 w-full placeholder-foreground-400"
                    />
                  </div>
                </div>
              )}
            </div>
            <Link
              to="/about"
              className="hidden md:flex items-center gap-2 px-4 py-2 bg-primary-500 text-white rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-vip-crown-line"></i>
              会员中心
            </Link>
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className={`text-lg text-foreground-700 ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3">
          <div className="flex flex-col gap-1">
            <Link
              to="/"
              className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 cursor-pointer"
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}